// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PaperClipOutlinedSvg from "@ant-design/icons-svg/es/asn/PaperClipOutlined";
import AntdIcon from '../components/AntdIcon';

var PaperClipOutlined = function PaperClipOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PaperClipOutlinedSvg
  }));
};

PaperClipOutlined.displayName = 'PaperClipOutlined';
export default React.forwardRef(PaperClipOutlined);